import { UseQueryOptions } from '@tanstack/react-query';
import { ApiKeyConfig, GetAllByUserIDPath, urlCombine } from 'ihub/common';
import { CRUDHelperBase } from '../classes/crud-helper-base';
import {
	coreAPI,
	getTenantID,
	isURLSet,
	standardGet,
	validateOkResponse,
} from '../classes/http-helper-const';
import { cacheStaleTime } from '../constants';
import QueryClientWrapper from '../utils/create-query-client';

export class ApiKeyHttpService extends CRUDHelperBase<ApiKeyConfig> {
	constructor() {
		super(ApiKeyConfig.name);
	}

	getAllByUserID(): UseQueryOptions<ApiKeyConfig[], Error, ApiKeyConfig[]> {
		return {
			queryKey: [getTenantID(), this.objectType, GetAllByUserIDPath],
			queryFn: async (): Promise<ApiKeyConfig[]> => {
				isURLSet();
				const url = urlCombine(coreAPI, this.objectType, GetAllByUserIDPath);
				const res = await standardGet(url);
				validateOkResponse(res, 'get all by ID', this.objectType);
				return await res.clone().json();
			},
			staleTime: cacheStaleTime,
		};
	}

	async invalidateGetAllByUserID() {
		await QueryClientWrapper.InvalidateKey(
			[getTenantID(), ApiKeyConfig.name, GetAllByUserIDPath],
			false
		);
	}
}
